export default {
  key: 'en_us',
  langName: 'English',
  unableSubmit: '*无法提交时请检查其他语种*',
  closeOther: "Close other",
  closeAll: "Close all",
  yes: "Yes",
  no: "No",
  search: "Search",
  choose: "Choose ",
  chooseTenant: "Choose tenant",
  add: "Add",
  edit: "Edit",
  addItem: "新增项目",
  editItem: "编辑项目",
  delete: "Delete",
  submit: "Submit",
  cancel: "Cancel",
  prompt: "Prompt",
  enabled: "Enabled",
  disable: "Disable",
  success: "Success",
  operation: "Operation",
  download: "Download",
  save: "Save",
  pleaseEnter: "Please enter ",
  pleaseChoose: "Please choose ",
  deletePrompt: "Are you sure to delete it?",
  deleteAllPrompt: "Are you sure to delete all?",
  deleteSuccess: "Delete Success",
  selectRow: "Select a row of data！",
  submitPrompt: "Confirm the submission?",
  uploadImgLabel: "Upload images",
  uploadFileLabel: "Upload Files",
  uploadtipStart: "只能上传",
  uploadtipEnd: "文件，且不超过2MB",
  uploadClick: "Click on the upload",
  deleteImgPrompt: "确定删除吗？删除后不可恢复.",
  pleaseUpload: "please upload files!",
  recoverImgPrompt: "设置为封面吗？",
  balance: "余额",
  EnterContent: "Enter content...",
  EnterAmount: "请输入金额",
  Number: "Number",
  Address: "Address",
  Fies: "Fies",
  System: "System",
  Cover: "Cover",
  ShareCover: "Share Cover",
  Name: "Name",
  Phone: "Phone",
  Remark: "Remark",
  ZipCode: "Zip Code",
  Enabled: "Enabled",
  Created: "Created Time",
  CreatedName: "Created Name",
  ModifiedName: "Admin",
  Modified: "Modified Time",
  Model: "Model",
  TypeName: "Type",
  AreaName: "Area",
  Mobile: "Mobile",
  Contract: "Contract",
  Status: "Status",
  Payment: "Payment",
  PaymentTerm: "Payment Term",
  Amount: "Amount",
  PaymentAmount: "Payment Amount",
  Active: "Active",
  ActualAmount: "Actual Amount",
  DateTime: "DateTime",
  StartDateTime: "Start DateTime",
  EndDateTime: "End DateTime",
  Operation: "Operation",
  Detailed: "Detailed",
  Occupation: "Occupation",
  Gender: "Gender",
  PassType: "Pass Type",
  SelectEstate: "Select Estate",
  Approver: "Approver",
  Value: "Value",
  AllType: "All type",
  Day: "Day",
  BasicInfo: "Basic info",
  PrevSteps: "Prev",
  NextSteps: "Next",
  Cellphone: "Cellphone",
  uploadImgLabel: "Upload",
  uploadChoose: "Choose",
  Price: "Price",
  Reco: "Reco",
  Spec: "Spec",
  Items: "Items",
  Hot: "Hot",
  Introduce: "Introduce",
  LowestNumber: "最小量",
  MaxNumber: "最大量",
  Sort: "Sort",
  ZeroChoose: "请选择信息",
  Timeframe: "时间段",
  Total: "Total",
  SearchProduct: "Search Product",
  Week: "Week",
  Mode: "模式",
  PayMode: "Payment",
  GenderList: {
    1: 'Mr',
    2: 'Ms'
  },
  admininfo: {
    settings: "Settings",
    outlogin: "Log out"
  },
  Roles: {
    Name: "RoleName",
    Description: "Description",
  },
  AdminUser: {
    NickName: "NickName",
    LoginName: "LoginName",
    RoleName: "Role",
    Password: "Password",
    ResetPass: "Are you sure to reset the password to 00000?",
  },
  Module: {
    LinkUrl: "Link url",
    Name: "Name",
  },
  Permission: {
    Name: "Menu/Button",
    Code: "Router url",
    MName: "API",
    IsButton: "Is button",
    IsHide: "Is hide",
    Description: "Description",
    Func: "Func",
    PidArr: "Parent menu"
  },
  Notification: {
    Title: "Title",
    Content: "Content",
    Send: "Send",
    SendCount: "Send Count",
    SendConfirm: "Are you sure to send it？",
    TypeList: {
      1: "Landlord",
      2: "Tenant"
    },
    ModelList: {
      1: "All",
      2: "Private"
    },
  },
  Shop: {
    Name: "Shop Name",
    OrderNumber: "Order Number",
    LowestPrice: "Lowest Price",
    FreightDerate: "运费减免比例%",
    PostageInfo: "Postage Info",
    ShareLink: "链接",
    WxOpenUrl: "WxOpen Url",
    DelayDay: "Delay Day",
    ClearingTime: "Clearing Time",
    Area: "Shop Area",
    Distance: "自送配送距离",
    DeliveryModel: "配送方式",
    Intro: "Intro",
    ListIntro: "List Intro",
    DeliveryModelList: {
      1: "自送距离模式",
      2: "车队距离配送",
      3: "固定配送",
      4: "混合配送"
    },
  },
  Product: {
    Type: "Product Type",
    ItemQTY: "Item QTY"
  },
  HistoryFolder: {
    TypeList: {
      1: "Public",
      2: "Private"
    },
    HistoryData: "Data",
    UploadData: "Upload Data"
  },
  Order: {
    OrderNo: "OrderNo",
    Freight: "Freight",
    payImage: "转账截图",
    SubmitTime: "Submit time",
    EditStatus: "Status",
    EditAllStatus: "批量修改状态",
    ShippingDate: "配送日期",
    UpdateTotal: "Upd total",
    LimitMode: "限购方式",
    selStatusList: {
      0: "全部状态",
      101: "等待付款",
      102: "等待商家接单",
      201: "已确认待送达",
      202: "等待骑手接单",
      203: "骑手已接单",
      204: "骑手派送中",
      300: "配送完成",
      401: "订单取消",
      402: "申请退款",
      403: "已退款",
    },
    StatusList: {
      101: "等待付款",
      102: "等待商家接单",
      201: "已确认待送达",
      202: "等待骑手接单",
      203: "骑手已接单",
      204: "骑手派送中",
      300: "配送完成",
      401: "订单取消",
      402: "申请退款",
      403: "已退款",
    },
    LimitModeList: {
      1: "每单",
      2: "每天",
      3: "每人"
    },
    ModeList: {
      1: "商城",
      2: "餐饮"
    },
    PayType: {
      1: "PayNow",
      2: "银行转账",
      3: "微信支付",
      4: "其他支付"
    }
  },
  Express: {
    StatusList: {
      1: "等待安排骑手",
      2: "骑手已接单",
      3: "取消",
      4: "已取货",
      5: "拒绝",
      6: "完成",
      7: "过期",
    },
  },
  CashFlowType: {
    1: "订单收入",
    2: "运费收入",
    3: "管理费支出",
    4: "配送支出",
    5: "退款支出",
    6: "拼单返利",
    7: "提现",
    8: "GST",
    9: "管理费返还"
  },
  Transaction: {
    Type: {
      1: "拼单支付",
      2: "超时未支付退款",
      3: "订单退款",
      4: "红包",
      5: "储值",
      6: "返利"
    }
  },
  TourDiy: {
    StatusList: {
      1: "进行中",
      2: "已结束"
    },
    SendStatusList: {
      1: "未发奖",
      2: "已发送"
    },
    ShopStatusList: {
      1: "等待确认",
      2: "商家已确认",
      3: "已完成"
    },
  },
  Recharge: {
    StatusList: {
      1: "等待付款",
      2: "等待审核",
      3: "审核失败",
      4: "已完成",
      5: "已取消",
    },
  },
  ShopDateEvent: {
    ModeList: {
      1: "全体",
      2: "商户"
    },
    TypeList: {
      1: "暂停销售",
      2: "订单备注",
      3: "增加服务费"
    }
  },
  ShopPayoutStatus: {
    1: "审核中",
    2: "已通过",
    3: "已取消",
    4: "驳回",
  }
}